import { environment } from '../../../../../environments/environment';
import { MissingArgumentsError } from '../../../../models/errors/general.errors';
import { IOrgContext } from '../../../../models/organization/organization-model';

const BASE_URL = environment.api;

const ORGANIZATION_BASE_URL = BASE_URL + '/auth/organization';

export const ORGANIZATION_CREATE_POST_URL = ORGANIZATION_BASE_URL + '/';
export const ORGANIZATION_GET_ALL_URL = ORGANIZATION_BASE_URL + '/list';
class OrganizationUrls {
    public getOrganDetailsGETUrl(orgContext: IOrgContext) {
        return this.getDetailsOrganUrl(orgContext);
    }

    public getOrganUpdateFieldsPUTUrl(orgContext: IOrgContext) {
        return this.getDetailsOrganUrl(orgContext);
    }
    public getAllOrganUsersGETUrl(orgContext: IOrgContext) {
        return `${this.getDetailsOrganUrl(orgContext)}/all-users`;
    }

    public getDetailsOrganUrl(orgContext: IOrgContext) {
        if (!orgContext || !orgContext.organizationId) {
            throw new MissingArgumentsError('Could not get details organization url because organization id is null');
        }

        return `${ORGANIZATION_BASE_URL}/${orgContext.organizationId}`;
    }
}

export default new OrganizationUrls();
